/* Pawlyo — scripts propios (vanilla, sin librerías) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.pw-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('pw-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('pw-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function money(cents, tpl) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (tpl || '{{amount}} €').replace('{{amount}}', v).replace('{{amount_with_comma_separator}}', v);
  }

  function initQuiz() {
    document.querySelectorAll('[data-pw-quiz]').forEach(function (root) {
      var data;
      try { data = JSON.parse(root.querySelector('[data-pw-quiz-data]').textContent); } catch (e) { return; }
      var steps = root.querySelectorAll('[data-pw-step]');
      var dots = root.querySelectorAll('.pw-quiz__dot');
      var result = root.querySelector('[data-pw-result]');
      var answers = [];
      var current = 0;

      function show(i) {
        steps.forEach(function (s, idx) { s.hidden = idx !== i; });
        dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx <= i); });
        result.hidden = true;
      }
      function recommend() {
        // score: 0 = 1 vaso, 1 = 2 vasos, 2 = kit
        var score = { 0: 0, 1: 0, 2: 0 };
        answers.forEach(function (a) { score[a] += 1; });
        var best = 0;
        [0, 1, 2].forEach(function (k) { if (score[k] > score[best]) best = k; });
        // el pelo en el sofá manda: si lo dicen, kit
        if (answers[2] === 2) best = 2;
        var v = data.variants[best] || data.variants[0];
        steps.forEach(function (s) { s.hidden = true; });
        dots.forEach(function (d) { d.classList.add('is-on'); });
        result.hidden = false;
        result.querySelector('[data-pw-r-name]').textContent = v.title;
        result.querySelector('[data-pw-r-price]').textContent = v.price_fmt;
        result.querySelector('[data-pw-r-why]').textContent = data.why[best];
        var link = result.querySelector('[data-pw-r-link]');
        link.href = data.url + (v.id ? (data.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : '');
      }
      root.querySelectorAll('[data-pw-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers[current] = parseInt(btn.getAttribute('data-pw-opt'), 10);
          current += 1;
          if (current >= steps.length) recommend(); else show(current);
        });
      });
      var reset = root.querySelector('[data-pw-reset]');
      if (reset) reset.addEventListener('click', function () { answers = []; current = 0; show(0); });
      show(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initQuiz();
  });
})();
